module.exports = __webpack_public_path__ + "static/media/takeover.b7df94af.svg";